import { FC, useContext, useEffect, useState } from 'react';
import {
  SearchUnallocatedByWasteItemConditions,
  UnallocatedTaskByWasteItem,
} from '../../../../../../types/carAllocation';
import Conditions from './Conditions';
import styles from './styles.module.css';
import Pagenation from '../../../../../../components/common/Pagenation';
import { useSearchUnallocatedByWasteItemQuery } from '../../../../../../api/carAllocationApi';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../../../../../../redux/store';
import { setEditTask } from '../../../../../../redux/carAllocationEditSlice';
import { addMinutes, format } from 'date-fns';
import Tables from './Tables';
import ModalFooter from '../ModalFooter';
import SelectPageSize from '../../../../../../components/common/SelectPageSize';
import NoResultFound from '../../../../../../components/common/NoResultFound';
import { startDateContext } from '../startDateContext';

const initConditions: SearchUnallocatedByWasteItemConditions = {
  startDate: format(new Date(), 'yyyy-MM-dd'),
  contractNo: '',
  companyName: '',
};
const SelectUnallocatedTask: FC = () => {
  const startDate = useContext(startDateContext);
  useEffect(() => {
    setConditions({ ...conditions, startDate });
  }, [startDate]);
  const [conditions, setConditions] =
    useState<SearchUnallocatedByWasteItemConditions>({
      ...initConditions,
      startDate,
      page: 1,
      limit: 20,
    });
  const { data: unallocateds } =
    useSearchUnallocatedByWasteItemQuery(conditions);
  const [selectedUnallocated, onSelectUnallocated] =
    useState<UnallocatedTaskByWasteItem | null>(null);
  const inEditState = useSelector(
    (state: AppState) => state.carAllocationEdit.editState
  );

  useEffect(() => {
    if (inEditState?.primary.contractId && selectedUnallocated === null)
      // 念のため unallocateds がキャッシュヒットしなかった場合にも選択状態を反映させるため useEffect を使用する
      onSelectUnallocated(
        unallocateds?.unallocatedCarAllocations.find(
          (uca) =>
            uca.contractId === inEditState?.primary.contractId &&
            uca.workCategories.some(
              (wc) => wc.id === inEditState.primary.workCategory?.id
            ) &&
            uca.wasteItems?.id === inEditState.primary.wasteItemId
        ) ?? null
      );
  }, [unallocateds]);
  const dispatch = useDispatch<AppDispatch>();
  const onNext = () => {
    if (!selectedUnallocated || !inEditState) {
      return;
    }

    dispatch(
      setEditTask({
        ...inEditState,
        primary: {
          ...inEditState.primary,
          type: 'unallocated',
          contractId: selectedUnallocated.contractId,
          contractDetailId: selectedUnallocated.contractDetailId,
          wasteItemId: selectedUnallocated.wasteItems?.id,
          workCategory: selectedUnallocated.workCategories[0],
          endDate: inEditState.primary.startDate
            ? addMinutes(
                new Date(inEditState.primary.startDate),
                selectedUnallocated.workCategories[0].estimatedTime
              ).toISOString()
            : undefined,
          goesStraight: selectedUnallocated.goesStraight,
          isEditable: {
            vertical: true,
            horizontal: true,
          },
          isMergeTask: inEditState.primary.isMergeTask,
        },
        secondary: {
          ...inEditState.secondary,
          type: 'unallocated',
          contractId: selectedUnallocated.contractId,
          contractDetailId: selectedUnallocated.contractDetailId,
          wasteItemId: selectedUnallocated.wasteItems?.id,
          workCategory: selectedUnallocated.workCategories[1],
          goesStraight: selectedUnallocated.goesStraight,
          isEditable: {
            vertical: true,
            horizontal: true,
          },
        },
        step: 2,
      })
    );
  };

  const noResult = unallocateds?.unallocatedCarAllocations?.length === 0;

  return (
    <div className={styles.container}>
      <Conditions
        initConditions={initConditions}
        conditions={conditions}
        updateConditions={setConditions}
      />
      {!noResult ? (
        <>
          <div className={styles.pagenationContainer}>
            <SelectPageSize
              value={`${conditions.limit}`}
              onChange={(e) =>
                setConditions({
                  ...conditions,
                  page: 1,
                  limit: Number(e.target.value),
                })
              }
            />
            <Pagenation
              page={conditions.page || 1}
              perPage={conditions.limit || 20}
              onPage={(page) =>
                setConditions({
                  ...conditions,
                  page,
                })
              }
              total={unallocateds?.total || 0}
            />
          </div>
          <div className={styles.tableContainer}>
            <Tables
              selected={selectedUnallocated}
              list={unallocateds?.unallocatedCarAllocations || []}
              onSelect={onSelectUnallocated}
            ></Tables>
          </div>
        </>
      ) : (
        <div className={styles.noResultFound}>
          <div className={styles.noResultFoundPadding}>
            <NoResultFound />
          </div>
        </div>
      )}
      <ModalFooter onNext={onNext} disabledOnNext={!selectedUnallocated} />
    </div>
  );
};

export default SelectUnallocatedTask;
